import { z } from 'zod';
import { rolesSchema } from './role.schema';

export const authUserSchema = z.object({
  forcePasswordReset: z.boolean().nullish(),
  userId: z.number().min(1),
  username: z.string().min(1),
  authToken: z.string().min(1),
  accountName: z.string().nullable(),
  accountId: z.number().min(1),
  firstName: z.string().min(1).nullable(),
  lastName: z.string().min(1).nullable(),
  email: z.string().min(1).optional(),
  roles: z.array(rolesSchema),
  currentTermsAccepted: z.number().nullable(),
  accessToken: z.string().nullable(),
  idToken: z.string().nullable(),
});

export type AuthUser = z.infer<typeof authUserSchema>;
